import theme from '../themes/default'

export default {
  wrap: {
    'margin-top': '5px',
    '& .am-grid': {
      '& .am-flexbox': {
        background: 'transparent !important',
      },
    },
  },
  'grid-item-wrap': {
    position: 'relative',
    height: '100%',
  },
  'grid-item-detail': {
    position: 'absolute',
    color: '#fff',
    background: '#000',
    padding: '10px',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/Grid.js